export default __webpack_public_path__ + "static/media/testimoni2.1e4ac141.webp";